import { useState } from "react";
import { updateUserConfigRequest } from "../requests/user/config";
import { useAuth } from "../../contexts/auth/Context";
import { useToast } from "../../contexts/toast/Context";
import type { UpdateUserConfigInput } from "../requests/user/config";

export const useUpdateUserConfig = (onSuccess?: () => void) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { token } = useAuth();
  const { showToast } = useToast();

  const updateUserConfig = async (input: UpdateUserConfigInput) => {
    if (!token) {
      const errorMsg = "No hay token de autenticación";
      setError(errorMsg);
      showToast(errorMsg, "error");
      return false;
    }

    setIsLoading(true);
    setError(null);

    try {
      await updateUserConfigRequest(input, token);
      showToast("Configuración guardada correctamente", "success");
      if (onSuccess) {
        onSuccess();
      }
      return true;
    } catch (err) {
      const errorMessage =
        err instanceof Error
          ? err.message
          : "Error al guardar la configuración";
      setError(errorMessage);
      showToast(errorMessage, "error");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    updateUserConfig,
    isLoading,
    error,
  };
};
